import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,_vm._g(_vm._b({attrs:{"color":_vm.color,"dark":_vm.dark,"dense":_vm.dense,"disabled":_vm.disabled}},'v-list-item',_vm.attrs,false),Object.assign({}, _vm.dialog)),[_c(VListItemIcon,[_c(VIcon,[_vm._v(_vm._s(_vm.iconName))])],1),_c(VListItemTitle,[_vm._v(_vm._s(_vm._f("capitalize")(_vm.title)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }